// 第三方登录展示配置。授权地址和回调处理统一交给后端授权登录客户端。
// Apple 走前端 JS SDK（弹窗），配置见 appleAuthInfo。
import { isDingTalk } from "~/utils/common";

const currentDomain = import.meta.client ? window.location.hostname : "";
const isLocalDomain =
	currentDomain === "localhost" ||
	currentDomain === "127.0.0.1" ||
	currentDomain === "::1" ||
	/^192\.168\./.test(currentDomain) ||
	/^10\./.test(currentDomain) ||
	/^172\.(1[6-9]|2\d|3[0-1])\./.test(currentDomain);

const canThirdDomain = [
	"localhost",
	"127.0.0.1",
	"::1",
	"10.1.20.43",
	"seerq.io",
	"www.seerq.io",
	"sandbox-gw.seeronnet.com",
	"sandbox-seer.seeronnet.com",
	"www.seeronnet.net",
	"www.seeronnet.com",
	"www.hspiritlink.com",
];

const isRegularDomainAllowed = currentDomain ? canThirdDomain.includes(currentDomain) : false;
const isDomainAllowed = isLocalDomain || isRegularDomainAllowed;

// Apple Developer 已登记的 Return URL 域名；不在此列表则不展示 Apple 登录
const appleAllowedDomains = [
	"sandbox-seer.seeronnet.com",
	"seerq.io",
	"www.seerq.io",
	"www.seeronnet.net",
	"www.seeronnet.com",
	"www.seerq.net",
	"seerq.net",
	"seerq.tw",
];
const isAppleDomainAllowed = Boolean(currentDomain) && appleAllowedDomains.includes(currentDomain);

// 回调地址取当前访问域名 origin（须与 Apple 后台 Return URL 完全一致）
const getAppleRedirectUri = () => {
	if (!import.meta.client) return "https://seerq.io";
	return window.location.origin;
};

const appleAuthInfo = {
	client_id: "com.seer.signin",
	get redirect_uri() {
		return getAppleRedirectUri();
	},
};

const allThirdLogins = [
	{
		name: "Google",
		icon: new URL("@/assets/images/login_ic_google.png", import.meta.url).href,
		type: "google",
	},
	{
		name: "LINE",
		icon: new URL("@/assets/images/login_ic_line.png", import.meta.url).href,
		type: "line",
	},
	{
		name: "Facebook",
		icon: new URL("@/assets/images/login_ic_facebook.png", import.meta.url).href,
		type: "facebook",
	},
	{
		name: "Apple",
		icon: new URL("@/assets/images/login_ic_apple.png", import.meta.url).href,
		type: "apple",
	},
];

// Android / 钉钉 WebView：Apple JS SDK 弹窗依赖 postMessage，环境不支持则隐藏入口
const isAndroidClient = import.meta.client && /Android/i.test(navigator.userAgent || "");
const hideAppleLogin = isAndroidClient || isDingTalk() || !isAppleDomainAllowed;

const thirdLoginList = (isDomainAllowed ? allThirdLogins : []).filter(
	item => !(hideAppleLogin && item.type === "apple")
);

export { thirdLoginList, appleAuthInfo };
